import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d00371e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"margin-top":"24px"},
  class: "flex align-center wrap"
}
const _hoisted_2 = { class: "flex grow" }
const _hoisted_3 = {
  key: 0,
  class: "flex align-center justify-between grow"
}
const _hoisted_4 = { class: "flex align-center wrap" }
const _hoisted_5 = {
  style: {"width":"200px","white-space":"nowrap"},
  class: "text-muted"
}
const _hoisted_6 = { class: "flex grow" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"25px"} }, null, -1))
const _hoisted_9 = { class: "flex col" }
const _hoisted_10 = { class: "flex align-center p12" }
const _hoisted_11 = { class: "text-muted bold" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "30",
    height: "30",
    src: "ico/probe-blue.svg"
  })
], -1))
const _hoisted_13 = {
  key: 1,
  class: "flex col justify-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "30",
    height: "30",
    src: "ico/probe-blue.svg"
  })
], -1))
const _hoisted_15 = {
  key: 2,
  class: "text-red"
}
const _hoisted_16 = { class: "flex col" }
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = { class: "subtitle" }
const _hoisted_19 = { class: "grid single" }
const _hoisted_20 = { class: "text-muted no-mobile" }
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "flex col" }
const _hoisted_24 = { class: "flex align-center" }
const _hoisted_25 = { class: "subtitle" }
const _hoisted_26 = { class: "flex align-center" }
const _hoisted_27 = { class: "subtitle" }
const _hoisted_28 = { class: "flex col panel" }
const _hoisted_29 = { class: "flex justify-between align-center" }
const _hoisted_30 = { class: "grid single" }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { class: "flex g6" }
const _hoisted_33 = { class: "flex col" }
const _hoisted_34 = { class: "flex col" }
const _hoisted_35 = { class: "tab-row" }
const _hoisted_36 = {
  class: "tab-row",
  style: {"padding-right":"12px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Illustration", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeTextarea = _resolveComponent("SeTextarea")!
  const _component_SeForm = _resolveComponent("SeForm")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeDropdownFilter = _resolveComponent("SeDropdownFilter")!
  const _component_SeIllustration = _resolveComponent("SeIllustration")!
  const _component_LockedField = _resolveComponent("LockedField")!
  const _component_SeVerticalTab = _resolveComponent("SeVerticalTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "attachmentModal",
      title: "Edit"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeInput, {
          ref: "attachmentName",
          modelValue: _ctx.attachmentName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attachmentName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SeButton, {
          onPress: _ctx.editAttachment,
          class: "modal-valid w100"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: _ctx.labelModalMode == 'create'
    ? _ctx.Lang.getI18N('new-label')
    : _ctx.Lang.getI18N('edit-label')
    ,
      ref: "labelModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeForm, {
          ref: "submitForm",
          class: "flex col label-modal",
          style: {"width":"80vw","max-width":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SeInput, {
              required: "",
              ref: "labelName",
              placeholderBase: _ctx.Lang.getI18N('name'),
              modelValue: _ctx.currentLabel.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentLabel.name) = $event))
            }, null, 8, ["placeholderBase", "modelValue"]),
            _createVNode(_component_SeDropdown, {
              titleFunc: (value) => _ctx.Lang.getI18N(value),
              modelValue: _ctx.currentLabel.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentLabel.type) = $event)),
              ref: "labelTypeSelect"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.Defrosting
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.Expiration
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.CustomerExpiration
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.Name
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.FreeformExpiration
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.Opening
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.Frozen
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.DefrostingEditable
                }, null, 8, ["value"]),
                _createVNode(_component_SeDropdownItem, {
                  value: _ctx.LabelType.ExpirationEditable
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["titleFunc", "modelValue"]),
            _withDirectives(_createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_SeInput, {
                  required: "",
                  numberOnly: true,
                  ref: "expirationDurationDays",
                  placeholder: _ctx.Lang.getI18N('days')
                }, null, 8, ["placeholder"]),
                (
            _ctx.currentLabel.getType(_ctx.getLabelLock()) !=
            _ctx.LabelType.HourlessExpiration &&
            _ctx.currentLabel.getType(_ctx.getLabelLock()) !=
            _ctx.LabelType.CustomerExpiration
          )
                  ? (_openBlock(), _createBlock(_component_SeInput, {
                      key: 0,
                      required: "",
                      numberOnly: true,
                      ref: "expirationDurationHours",
                      placeholder: _ctx.Lang.getI18N('hours')
                    }, null, 8, ["placeholder"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.Expiration || _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.ExpirationEditable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_ToggleSwitch, {
                      class: "grow",
                      style: {"flex":"0 0 0"},
                      modelValue: _ctx.currentLabel.show_expiration_hour,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentLabel.show_expiration_hour) = $event)),
                      defaultValue: _ctx.currentLabel.getShowExpirationHour(_ctx.getLabelLock())
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("show-hour")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "defaultValue"]),
                    _createVNode(_component_ToggleSwitch, {
                      class: "grow",
                      style: {"flex":"0 0 0"},
                      modelValue: _ctx.currentLabel.show_expiration_weekday,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentLabel.show_expiration_weekday) = $event)),
                      defaultValue: _ctx.currentLabel.getShowExpirationWeekday(_ctx.getLabelLock())
            
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("show-weekday")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "defaultValue"])
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.Expiration ||
        _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.Defrosting ||
        _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.DefrostingEditable ||
        _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.ExpirationEditable ||
        _ctx.currentLabel.getType(_ctx.getLabelLock()) ==
        _ctx.LabelType.CustomerExpiration ||
        _ctx.currentLabel.getType(_ctx.getLabelLock()) ==
        _ctx.LabelType.HourlessExpiration ||
        _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.FreeformExpiration
        ]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Lang.getI18N("defrosting-duration")) + " : ", 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_SeInput, {
                  required: "",
                  numberOnly: true,
                  ref: "defrostingDurationDays",
                  placeholder: _ctx.Lang.getI18N('days')
                }, null, 8, ["placeholder"]),
                _createVNode(_component_SeInput, {
                  required: "",
                  numberOnly: true,
                  ref: "defrostingDurationHours",
                  placeholder: _ctx.Lang.getI18N('hours')
                }, null, 8, ["placeholder"])
              ])
            ], 512), [
              [_vShow, _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.Defrosting || _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.DefrostingEditable]
            ]),
            _createElementVNode("span", {
              ref: "freeformErrorMsg",
              style: {"display":"none"},
              class: "text-red"
            }, _toDisplayString(_ctx.Lang.getI18N("freeform-line-limit")), 513),
            _withDirectives(_createVNode(_component_SeTextarea, {
              ref: "expirationText",
              placeholderBase: "Text",
              inputChange: _ctx.onFreeformInputChange,
              style: {"height":"200px"}
            }, null, 8, ["inputChange"]), [
              [_vShow, _ctx.currentLabel.type == _ctx.LabelType.FreeformExpiration]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ToggleSwitch, {
                ref: "cumulateExprSwitch",
                modelValue: _ctx.currentLabel.cumulate_expiration_duration,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentLabel.cumulate_expiration_duration) = $event)),
                auto: "true"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("cumulative-expirations")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 512), [
              [_vShow, _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.Defrosting || _ctx.currentLabel.getType(_ctx.getLabelLock()) == _ctx.LabelType.DefrostingEditable]
            ]),
            _createVNode(_component_SeButton, {
              class: "modal-valid",
              onPress: _ctx.labelModalMode == 'create' ? _ctx.createLabel : _ctx.editLabel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.labelModalMode == "create"
            ? _ctx.Lang.getI18N("add")
            : _ctx.Lang.getI18N("close")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeVerticalTab, {
      class: "grow",
      ref: "tab",
      tabs: [
    _ctx.ModuleEnum.Temperatures,
    _ctx.ModuleEnum.Labels,
    _ctx.ModuleEnum.Traceability,
    _ctx.ModuleEnum.Oils,
    _ctx.ModuleEnum.TemperatureControl,
    'encyclopedia',
    'settings',
  ],
      hiddenTabs: _ctx.hiddenModules,
      labels: [
    _ctx.Lang.getI18N('temperatures'),
    _ctx.Lang.getI18N('labels'),
    _ctx.Lang.getI18N('traceability'),
    _ctx.Lang.getI18N('oils'),
    _ctx.Lang.getI18N('temperature_control'),
    _ctx.Lang.getI18N('encyclopedia'),
    _ctx.Lang.getI18N('recipe'),
  ],
      icons: [
    '/ico/temperature.svg',
    '/ico/printer.svg',
    '/ico/camera.svg',
    '/ico/oils.svg',
    '/ico/temperature_control.svg',
    '/ico/encyclopedia.svg',
    '/ico/allergen.svg',
  ],
      style: {"margin":"24px 0px 0px 0px"},
      onTabChanged: _ctx.onTabChanged
    }, {
      tail0: _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.temperatures_module_active_lock,
          class: "tailing-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
              defaultValue: _ctx.element.getTemperaturesModuleActive(),
              modelValue: _ctx.element.temperatures_module_active,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.element.temperatures_module_active) = $event))
            }, null, 8, ["defaultValue", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      tail1: _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.labels_module_active_lock,
          class: "tailing-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
              defaultValue: _ctx.element.getLabelsModuleActive(),
              modelValue: _ctx.element.labels_module_active,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.element.labels_module_active) = $event))
            }, null, 8, ["defaultValue", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      tail2: _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.traceability_module_active_lock,
          class: "tailing-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
              defaultValue: _ctx.element.getTraceabilityModuleActive(),
              modelValue: _ctx.element.traceability_module_active,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.element.traceability_module_active) = $event))
            }, null, 8, ["defaultValue", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      tail3: _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.oils_module_active_lock,
          class: "tailing-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
              defaultValue: _ctx.element.getOilsModuleActive(),
              modelValue: _ctx.element.oils_module_active,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.element.oils_module_active) = $event))
            }, null, 8, ["defaultValue", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      tail4: _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.temperature_control_module_active_lock,
          class: "tailing-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              defaultValue: _ctx.element.getTemperatureControlModuleActive(),
              modelValue: _ctx.element.temperature_control_module_active,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.element.temperature_control_module_active) = $event))
            }, null, 8, ["defaultValue", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      tail5: _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.encyclopedia_extension_active_lock,
          class: "tailing-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              defaultValue: _ctx.element.getEncyclopediaExtensionActive(),
              modelValue: _ctx.element.encyclopedia_extension_active,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.element.encyclopedia_extension_active) = $event))
            }, null, 8, ["defaultValue", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      tail6: _withCtx(() => [
        _hoisted_8
      ]),
      "0": _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.element.originValue?.minimum_temperature_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeInput, {
                value: _ctx.element.getMinimumTemperature(),
                background: "#F3FAFA",
                numberOnly: true,
                placeholder: _ctx.Lang.getI18N('minimum-temperature'),
                modelValue: _ctx.element.minimum_temperature,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.element.minimum_temperature) = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["value", "placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.element.originValue?.maximum_temperature_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeInput, {
                value: _ctx.element.getMaximumTemperature(),
                background: "#F3FAFA",
                numberOnly: true,
                placeholder: _ctx.Lang.getI18N('maximum-temperature'),
                modelValue: _ctx.element.maximum_temperature,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.element.maximum_temperature) = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["value", "placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createVNode(_component_ReadonlyField, {
            class: "flex",
            locked: _ctx.element.originValue?.temperature_delivery_item_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ToggleSwitch, {
                defaultValue: _ctx.element.getTemperatureDeliveryItem(),
                auto: "true",
                modelValue: _ctx.element.temperature_delivery_item,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.element.temperature_delivery_item) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("delivery_item")), 1)
                ]),
                _: 1
              }, 8, ["defaultValue", "modelValue"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createVNode(_component_ReadonlyField, {
            class: "flex",
            locked: _ctx.element.originValue?.temperature_require_picture_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ToggleSwitch, {
                defaultValue: _ctx.element.getTemperatureRequirePicture(),
                auto: "true",
                modelValue: _ctx.element.temperature_require_picture,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.element.temperature_require_picture) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("requires-picture")), 1)
                ]),
                _: 1
              }, 8, ["defaultValue", "modelValue"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Lang.getI18N("probe")), 1),
            (_ctx.storeElementState.store.koovea_sticker == null)
              ? (_openBlock(), _createBlock(_component_SeDropdown, {
                  key: 0,
                  titleFunc: (x) => x.name,
                  ref: "probeSelect",
                  nullable: true,
                  modelValue: _ctx.storeElementState.selectedProbe,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.storeElementState.selectedProbe) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.probes, (probe) => {
                      return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                        class: "flex align-center",
                        value: probe
                      }, {
                        heading: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["titleFunc", "modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_SeDropdown, {
                    titleFunc: (x) => x.name,
                    nullable: true,
                    modelValue: _ctx.storeElementState.selectedTag,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.storeElementState.selectedTag) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.koovea_tags, (tag) => {
                        return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                          class: "flex align-center",
                          value: tag
                        }, {
                          heading: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["titleFunc", "modelValue"])
                ])),
            (_ctx.tagNotFound)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "La sonde précédemment selectionnée est introuvable. Modifiez la."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      "1": _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.labels_lock
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h1", _hoisted_18, _toDisplayString(_ctx.Lang.getI18N("labels")), 1),
                _createVNode(_component_SeButton, {
                  onPress: _ctx.openCreateLabelModal,
                  style: {"margin-top":"10px"},
                  icon: "ico/plus.svg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("new")), 1)
                  ]),
                  _: 1
                }, 8, ["onPress"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
                  return (_openBlock(), _createBlock(_component_WideCard, {
                    onClick: ($event: any) => (_ctx.openEditLabelModal(label)),
                    class: "shadow",
                    key: label.ref?.id,
                    icon: "/ico/equipement.svg",
                    title: label.getName(_ctx.getLabelLock())!,
                    obj: label
                  }, {
                    body: _withCtx(() => []),
                    subtitle: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(label.getDescription(_ctx.getLabelLock())), 1)
                    ]),
                    footer: _withCtx(() => [
                      _createVNode(_component_SeFadeButton, {
                        onClick: [
                          _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
                          ($event: any) => (_ctx.moveDownLabel(label))
                        ],
                        icon: "/ico/arrow-minimalistic-down.svg"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_SeFadeButton, {
                        onClick: [
                          ($event: any) => (_ctx.moveUpLabel(label)),
                          _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                        ],
                        icon: "/ico/arrow-minimalistic-up.svg"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_ToggleSwitch, {
                        onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"])),
                        modelValue: label.active,
                        "onUpdate:modelValue": ($event: any) => ((label.active) = $event),
                        defaultValue: label.getActive(),
                        auto: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "defaultValue"])
                    ]),
                    _: 2
                  }, 1032, ["onClick", "title", "obj"]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      "2": _withCtx(() => [
        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.Lang.getI18N("no-parameters")), 1)
      ]),
      "3": _withCtx(() => [
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.maximum_polarity_lock
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SeInput, {
              value: _ctx.element.getMaximumPolarity(),
              background: "#F3FAFA",
              numberOnly: true,
              placeholder: _ctx.Lang.getI18N('maximum-polarity'),
              modelValue: _ctx.element.maximum_polarity,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.element.maximum_polarity) = $event)),
              modelModifiers: { number: true }
            }, null, 8, ["value", "placeholder", "modelValue"])
          ]),
          _: 1
        }, 8, ["locked"]),
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.element.originValue?.require_oils_picture_lock
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_ToggleSwitch, {
                defaultValue: _ctx.element.getOilsRequirePicture(),
                modelValue: _ctx.element.oils_require_picture,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.element.oils_require_picture) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Requiers une image")
                ]),
                _: 1
              }, 8, ["defaultValue", "modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      "4": _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.Lang.getI18N("reheating")), 1)
          ]),
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.element.originValue?.reheating_temperature_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeInput, {
                background: "#F3FAFA",
                numberOnly: true,
                placeholder: _ctx.Lang.getI18N('reheating-temperature'),
                modelValue: _ctx.element.reheating_temperature,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.element.reheating_temperature) = $event)),
                modelModifiers: { number: true },
                value: _ctx.element.getReheatingTemperature()
              }, null, 8, ["placeholder", "modelValue", "value"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.element.originValue?.reheating_duration_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeInput, {
                background: "#F3FAFA",
                numberOnly: true,
                placeholder: _ctx.Lang.getI18N('reheating-duration'),
                modelValue: _ctx.element.reheating_duration,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.element.reheating_duration) = $event)),
                modelModifiers: { number: true },
                value: _ctx.element.getReheatingDuration()
              }, null, 8, ["placeholder", "modelValue", "value"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.Lang.getI18N("cooling")), 1)
          ]),
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.element.originValue?.cooling_temperature_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeInput, {
                background: "#F3FAFA",
                numberOnly: true,
                placeholder: _ctx.Lang.getI18N('cooling-temperature'),
                modelValue: _ctx.element.cooling_temperature,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.element.cooling_temperature) = $event)),
                modelModifiers: { number: true },
                value: _ctx.element.getCoolingTemperature()
              }, null, 8, ["placeholder", "modelValue", "value"])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.element.originValue?.cooling_duration_lock
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeInput, {
                background: "#F3FAFA",
                numberOnly: true,
                placeholder: _ctx.Lang.getI18N('cooling-duration'),
                modelValue: _ctx.element.cooling_duration,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.element.cooling_duration) = $event)),
                modelModifiers: { number: true },
                value: _ctx.element.getCoolingDuration()
              }, null, 8, ["placeholder", "modelValue", "value"])
            ]),
            _: 1
          }, 8, ["locked"])
        ])
      ]),
      "5": _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_ReadonlyField, {
            class: "flex col",
            locked: _ctx.element.originValue?.attachments_lock
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("attachments")), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.element.getAttachments(), (attachment) => {
                  return (_openBlock(), _createBlock(_component_WideCard, {
                    style: {"height":"auto !important","max-height":"auto"},
                    icon: "/ico/link.svg",
                    highlight: true,
                    selected: true,
                    title: attachment.name
                  }, {
                    subtitle: _withCtx(() => [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(attachment.type), 1)
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_SeFadeButton, {
                          onClick: () => _ctx.moveDownAttachement(attachment),
                          icon: "/ico/arrow-minimalistic-down.svg"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_SeFadeButton, {
                          onClick: () => _ctx.moveUpAttachement(attachment),
                          icon: "/ico/arrow-minimalistic-up.svg"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_SeFadeButton, {
                          onClick: () => _ctx.downloadAttachment(attachment),
                          icon: "/ico/download.svg"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_SeFadeButton, {
                          onClick: () => _ctx.openEditAttachmentModal(attachment),
                          icon: "/ico/edit-blue.svg"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_SeFadeButton, {
                          onClick: () => _ctx.deleteAttachment(attachment),
                          icon: "/ico/trash.svg"
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 256)),
                _createVNode(_component_SeFadeButton, {
                  class: "w100",
                  onClick: _ctx.uploadAttachment,
                  icon: "/ico/plus-blue.svg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Upload")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["locked"])
        ])
      ]),
      "6": _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.element.originValue?.secureat_display_active_lock,
              class: "flex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ToggleSwitch, {
                  defaultValue: _ctx.element.getSecureatDisplayActive(),
                  modelValue: _ctx.element.secureat_display_active,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.element.secureat_display_active) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Afficher dans Secureat Display ")
                  ]),
                  _: 1
                }, 8, ["defaultValue", "modelValue"])
              ]),
              _: 1
            }, 8, ["locked"]),
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.element.originValue?.allergens_lock
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("allergens")), 1),
                  _createVNode(_component_SeDropdownFilter, {
                    ref: "selectAllergens",
                    title: _ctx.Lang.getI18N('select-allergens'),
                    labelFunction: (allergenValue) => _ctx.Lang.getI18N(`allergen.${allergenValue}`),
                    items: _ctx.allergenValues,
                    onSelectedIndexesChange: _ctx.setSelectedAllergens
                  }, null, 8, ["title", "labelFunction", "items", "onSelectedIndexesChange"])
                ])
              ]),
              _: 1
            }, 8, ["locked"]),
            _createVNode(_component_LockedField, {
              locked: _ctx.element.originValue?.allergen_illustration_lock
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(_component_SeIllustration, {
                    onFilePick: (a, b) => _ctx.onAllergenIllustrationChange(a, b),
                    src: _ctx.element.allergen_illustration_url
                ? _ctx.element.allergen_illustration_url
                : '/ico/allergen.svg'
                ,
                    size: 24
                  }, null, 8, ["onFilePick", "src"])
                ])
              ]),
              _: 1
            }, 8, ["locked"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["tabs", "hiddenTabs", "labels", "onTabChanged"])
  ], 64))
}